import { LogManager } from "@mcleod/core";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutMobileCommReeferProfile } from "./autogen/AutogenLayoutMobileCommReeferProfile";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommReeferProfile");

const viewMCUnitCodeURL = "lme/dispatch/mobilecomm/MobileCommReeferProfile?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "mc_reefer_profile",
    screenName: "Mobile Comm Reefer Profile",
    navigateToUrl: viewMCUnitCodeURL
};

export class MobileCommReeferProfile extends AutogenLayoutMobileCommReeferProfile {
    async onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}
